import { Table, Button, Tooltip, Input, Space, Tag } from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { useState, useRef } from "react";

export default function ClientesIndex(props) {
  const { clientes, loading, onEdit, onDataChange } = props;
  const searchInput = useRef(null);

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Nombre</span>,
      dataIndex: "NombreCliente",
      key: "NombreCliente",
      render: (text) => text || <span className="subtle-text">N/D</span>,
      sorter: (a, b) => (a.NombreCliente || "").localeCompare(b.NombreCliente || ""),
      ...getColumnSearchProps("NombreCliente", "nombre"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Apodo/Alias</span>,
      dataIndex: "ApodoAlias",
      key: "ApodoAlias",
      render: (text) => text || <span className="subtle-text">N/D</span>,
      sorter: (a, b) => (a.ApodoAlias || "").localeCompare(b.ApodoAlias || ""),
      ...getColumnSearchProps("ApodoAlias", "apodo"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Teléfono</span>,
      dataIndex: "Telefono",
      key: "Telefono",
      render: (text) => text || <span className="subtle-text">N/D</span>,
      sorter: (a, b) => (a.Telefono || "").localeCompare(b.Telefono || ""),
      ...getColumnSearchProps("Telefono", "teléfono"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Correo Electrónico</span>,
      dataIndex: "CorreoElectronico",
      key: "CorreoElectronico",
      render: (text) => text || <span className="subtle-text">N/D</span>,
      sorter: (a, b) => (a.CorreoElectronico || "").localeCompare(b.CorreoElectronico || ""),
      ...getColumnSearchProps("CorreoElectronico", "correo"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Verificaciones</span>,
      dataIndex: "VerificacionesCount",
      key: "VerificacionesCount",
      align: "center",
      width: 150,
      render: (text) => (
        <Tag color={text > 0 ? "blue" : "default"}>
          {text || 0}
        </Tag>
      ),
      sorter: (a, b) => a.VerificacionesCount - b.VerificacionesCount,
      filters: [
        { text: "Con verificaciones", value: "active" },
        { text: "Sin verificaciones", value: "inactive" },
      ],
      onFilter: (value, record) => (value === "active" ? record.VerificacionesCount > 0 : record.VerificacionesCount === 0),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Acciones</span>,
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <Tooltip title="Editar Cliente">
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => onEdit(record.ClienteID)}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div style={{ fontSize: "13px" }}>
      <Table
        size="small"
        onChange={(pagination, filters, sorter, extra) => {
          if (onDataChange) {
            onDataChange(extra.currentDataSource);
          }
        }}
        columns={columns}
        dataSource={clientes}
        loading={loading}
        rowKey="ClienteID"
        pagination={{
          defaultPageSize: 25,
          showSizeChanger: true,
          showLessItems: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
}
